import { useEffect, useState } from "react";
import api from "@/lib/api";

let _cache = null;
export function clearDestCache() { _cache = null; }

export function DestinationPicker({ value, onChange, testid, className = "" }) {
  const [dests, setDests] = useState(_cache || []);
  const [customMode, setCustomMode] = useState(false);
  useEffect(() => {
    if (_cache) { setDests(_cache); return; }
    api.get("/control/destinations").then((r) => { _cache = r.data.destinations || []; setDests(_cache); }).catch(() => {});
  }, []);
  const paths = dests.map((d) => d.path);
  const isCustom = customMode || (!!value && !paths.includes(value));
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <select data-testid={testid}
        value={isCustom ? "__custom__" : (value || "")}
        onChange={(e) => { const v = e.target.value; if (v === "__custom__") setCustomMode(true); else { setCustomMode(false); onChange(v); } }}
        className="w-full rounded-lg border border-slate-200 px-2 py-1.5 text-xs">
        <option value="">— None —</option>
        {dests.map((d) => <option key={d.id} value={d.path}>{d.label}</option>)}
        <option value="__custom__">Custom path…</option>
      </select>
      {isCustom && (
        <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="/app/..."
          data-testid={testid ? `${testid}-custom` : undefined}
          className="w-28 rounded-lg border border-slate-200 px-2 py-1.5 text-xs" />
      )}
    </div>
  );
}
